export interface BeThemeOptions {
    logo_url_kind: "default" | "url" | "page" | "site_url";
    logo_url: string;
    logo_url_page: string;
    logo_url_target: string;
    smGridWidth: number;
    mdGridWidth: number;
    lgGridWidth: number;
    xlGridWidth: number;
    expand_current_menu_item: boolean;
}

export class BeTheme {

    private _options: BeThemeOptions;

    constructor() {
        if (!e5.Plugins.config?.betheme) {
            e5.console.warn(`[eventfive.wordpress-plugin]", "[BeTheme]", "BeTheme configuration missing. Maybe update config under "BeTheme > eventfive".`);
            return;
        }

        e5.console.log("[eventfive.wordpress-plugin]", "[BeTheme]");

        this._options = e5.Plugins.config.betheme;

        e5.Debug.add({
            uid: "betheme-responsive",
            tooltip: `BeTheme Breaktpoints:
                <br>SM ${this._options.smGridWidth}px
                <br>MD ${this._options.mdGridWidth}px
                <br>LG ${this._options.lgGridWidth}px
                <br>XL ${this._options.xlGridWidth}px
            `,
            label: "",
            onInit: (item) => {
                const updateLabel = () => {
                    const w = window.innerWidth;
                    if (w < this._options.smGridWidth) {
                        item.label = "SM";
                    }
                    else if (w < this._options.mdGridWidth) {
                        item.label = "MD";
                    }
                    else if (w < this._options.lgGridWidth) {
                        item.label = "LG";
                    }
                    else {
                        item.label = "XL";
                    }
                };
                window.addEventListener("resize", updateLabel);
                updateLabel();
            }
        });


        if (!e5.Plugins.config.isAdmin) {
            this.logoUrl();
        }

        if (this._options.expand_current_menu_item) {
            this.expandMenuItems();
        }

        /**
         * Close mobile menu on escape
         */
        document.addEventListener("keyup", (e) => {
            if (e5.KeyCode.is(e, e5.KeyCode.ESCAPE)) {
                const toggleButton = $("#Side_slide > div.close-wrapper > a");
                if (toggleButton.is(":visible")) {
                    toggleButton.trigger("click");
                }
            }
        });
    }

    private expandMenuItems(): void {
        document.querySelectorAll("#menu .current-menu-item")
            .forEach(
                (e) => {
                    let p = e.parentElement as HTMLElement;
                    while (p) {
                        if (p.classList.contains("menu-item")) {
                            p.classList.add("hover");
                        }
                        else if (p.classList.contains("sub-menu")) {
                            p.style.display = "block";
                        }
                        p = p.parentElement as HTMLElement;
                    }
                }
            );
    }

    /**
     * Logo URL
     */
    private logoUrl(): void {
        let logoUrl: string = "";
        if (this._options.logo_url_kind === "default") {
            //empty
        }
        else if (this._options.logo_url_kind === "url") {
            logoUrl = this._options.logo_url;
        }
        else if (this._options.logo_url_kind === "page") {
            logoUrl = this._options.logo_url_page;
        }
        else if (this._options.logo_url_kind === "site_url") {
            logoUrl = e5.Plugins.config.siteUrl;
        }

        if (logoUrl) {
            const logo = document.querySelector<HTMLAnchorElement>("#logo");
            if (!logo) {
                console.warn("Logo URL konnte nicht angepasst werden, da kein Logo gefunden wurde.");
            } else if (logo.tagName !== "A") {
                console.warn("Logo URL konnte nicht angepasst werden, da das Element kein HTMLAnchorElement ist.");
            } else {
                logo.href = logoUrl;
                logo.target = this._options.logo_url_target;
            }
        }
    }
}

e5.ready(() => {
    new BeTheme();
});